import { useSnackbar } from "notistack";
import Papa from "papaparse";
import { useState } from "react";

import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

import BackdropLoader from "../../../components/BackdropLoader";
import TooltipContainer from "../../../components/TooltipContainer";

import { useTranslation } from "react-i18next";
import List from "./List";

const Import = ({ mailingGroups }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [array, setArray] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const handleImportFile = (e) => {
		setIsLoading(true);
		setArray([]);
		const uploadedFile = e.target.files[0];

		Papa.parse(uploadedFile, {
			header: true,
			complete: function (results) {
				const headers = results.meta.fields.map((item) => item.toLowerCase());
				const requiredHeaders = ["company", "nip", "email"];

				if (!requiredHeaders.every((header) => headers.includes(header))) {
					enqueueSnackbar(t("import_carriers_invalid_headers_error"), {
						variant: "error",
						preventDuplicate: true,
					});
					setIsLoading(false);
					return;
				}

				const array = results.data.map((obj, index) => {
					const newMailingGroups = Object.entries(mailingGroups).reduce(
						(acc, [key, value]) => {
							return { ...acc, [key]: { name: value, checked: false } };
						},
						{}
					);

					const lowerCaseObj = Object.entries(obj).reduce(
						(newObj, [key, value]) => {
							return { ...newObj, [key.toLowerCase()]: value };
						},
						{}
					);

					return {
						...lowerCaseObj,
						lp: index + 1,
						mailingGroups: newMailingGroups,
					};
				});

				setArray(array);
				setTimeout(() => {
					setIsLoading(false);
				}, 300);
			},
		});
	};

	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Box
					sx={{
						position: "absolute",
						top: "13px",
						left: 0,
						zIndex: 120,
					}}
				>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							flexWrap: "wrap",
							columnGap: "20px",
							rowGap: "14px",
						}}
					>
						<Button component="label" variant="contained">
							{t("import_csv")}
							<input
								hidden
								type="file"
								id="csvFileInput"
								accept=".csv"
								onChange={handleImportFile}
							/>
						</Button>
						<Tooltip
							title={
								<TooltipContainer color="#63c29a">
									<p style={{ margin: 0 }}>{t("import_carriers_info_1")}</p>
									<p style={{ margin: 0 }}>
										{t("required_headers")}: <em>company</em>, <em>nip</em>,{" "}
										<em>email</em>
									</p>
									<p style={{ margin: 0 }}>
										{t("optional_headers")}: <em>firstname</em>,{" "}
										<em>lastname</em>, <em>phone</em>
									</p>
									<p>{t("import_carriers_info_2")}</p>
								</TooltipContainer>
							}
							placement="bottom"
							slotProps={{
								popper: {
									sx: {
										"& > div": { background: "#fff", p: 0, fontSize: "11px" },
									},
								},
							}}
						>
							<InfoIcon
								sx={{
									color: (theme) => theme.palette.primary.main,
									fontSize: "24px",
								}}
							/>
						</Tooltip>
					</Box>
				</Box>
				<List data={array} />
			</Box>
			<BackdropLoader isOpen={isLoading} />
		</>
	);
};

export default Import;
